module.exports = __webpack_public_path__ + "static/media/3d-rendering-server-room-server-computers.bf66d99d.jpg";